import { FileUpload } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { FileType } from 'libs/ui';
import {
  DocumentsTableFeature,
  FilesUploadFeature,
} from 'modules/account/common/features';

import { Field, MAX_FILES, useFormContext } from '../../../forms/orderForm';
import { OrderSection } from '../../OrderSection';

import { useConfirmationDocumentSection } from './useConfirmationDocumentSection';

export interface ConfirmationDocumentSectionProps {
  files?: FileUpload[];
}

export const ConfirmationDocumentSection = () => {
  const { t } = useTranslation();

  const { files, isDisabledField, isRequiredField } =
    useConfirmationDocumentSection();

  const { readOnly } = useFormContext();

  return (
    <OrderSection
      afterFields={
        readOnly ? (
          <DocumentsTableFeature
            documents={
              files?.map((file) => ({
                id: file.id!,
                size: file.size,
                name: file.name,
              })) ?? []
            }
          />
        ) : (
          <FilesUploadFeature
            fileTypes={[FileType.pdf]}
            maxFiles={MAX_FILES}
            name="confirmationDocument.files"
            title={t('account.createOrder.contract.documentTitle')}
          />
        )
      }
      fields={[
        <Field.Text
          fullWidth
          disabled={readOnly ? false : isDisabledField}
          label={t(
            'account.order.sections.confirmationDocumentSection.fields.contractNumber.label'
          )}
          name="confirmationDocument.contractNumber"
          placeholder={
            !isDisabledField
              ? t(
                  'account.order.sections.confirmationDocumentSection.fields.contractNumber.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequiredField}
        />,

        <Field.DatePicker
          fullWidth
          disabled={readOnly ? false : isDisabledField}
          label={t(
            'account.order.sections.confirmationDocumentSection.fields.contractDate.label'
          )}
          name="confirmationDocument.contractDate"
          placeholder={
            !isDisabledField
              ? t(
                  'account.order.sections.confirmationDocumentSection.fields.contractDate.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequiredField}
        />,
      ]}
      title={t('account.order.sections.confirmationDocumentSection.title')}
    />
  );
};
